export default __webpack_public_path__ + "static/media/partner-icon.f40afa80.svg";